module.exports = __webpack_public_path__ + "img/eposter.bb12f6b9.png";